import axios from "axios";
import { siteSettings } from "../static";

export async function uploadToCloudinary(file, onProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", siteSettings.uploadPreset);

  const response = await axios.post(
    `https://api.cloudinary.com/v1_1/${siteSettings.cloudName}/image/upload`,
    formData,
    {
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const total = progressEvent.total || progressEvent.loaded || 1;
          const progress = (progressEvent.loaded / total) * 100;
          onProgress(progress);
        }
      },
    }
  );

  return response.data.secure_url;
}
